// Who is using the app, from the Static Web App's auth endpoint (/.auth/me,
// populated by the Okta OIDC login that fronts production and staging).
//
// Needed because Salesforce cannot answer this: every write goes through the
// integration user, so the record's LastModifiedBy says the API, not the
// person. The handoff snapshot and the planning change log are the two places
// "who" actually matters, and this is where they get it.
//
// Best-effort by design: the demo build and local dev have no auth layer, and
// an identity fetch failing must never block a save or a snapshot. '' means
// unknown, and callers render it as such.

let cached = null;

export async function getUserIdentity() {
  if (cached !== null) return cached;
  try {
    const res = await fetch('/.auth/me', { headers: { Accept: 'application/json' } });
    if (!res.ok) return (cached = '');
    const body = await res.json();
    // SWA shape: { clientPrincipal: { userDetails, userId, ... } } — with
    // clientPrincipal null when unauthenticated.
    const p = body?.clientPrincipal;
    cached = String(p?.userDetails || '').trim();
  } catch {
    cached = '';
  }
  return cached;
}

// Test seam: reset the cache between tests.
export function __resetIdentityCache() {
  cached = null;
}
